(() => {
 'use strict';
 const root=document.querySelector('[data-bbab]');if(!root)return;
 const cfg=JSON.parse(document.getElementById('bbab-config').textContent), M=window.BB_BOX3;
 const q=s=>root.querySelector(s),qa=s=>[...root.querySelectorAll(s)];
 const state={...M.create(),ready:false,busy:false,review:false};
 let products=cfg.products||{},loadError='';
 const names=cfg.names;
 const money=n=>new Intl.NumberFormat('en-US',{style:'currency',currency:cfg.currency||'USD'}).format(n/100);
 const quote=(n=M.count(state),sub=state.sub)=>M.quote(state,n,sub,cfg.pricing);
 const bagWord=n=>n===1?'bag':'bags';
 function bind(k,v){qa('[data-bind="'+k+'"]').forEach(e=>e.textContent=v);}
 function status(message,cartLink=false){
  const e=q('[data-status]');e.textContent=message;
  if(cartLink){e.appendChild(document.createTextNode(' '));const a=document.createElement('a');a.href=cfg.base+'cart';a.textContent='View your cart';e.appendChild(a);}
 }
 function validation(){try{M.items(state,products,cfg);return '';}catch(e){return e.message;}}
 function oneTimeNote(n){
  if(n<=1)return 'Add one more bag to save 10%.';
  if(n===2)return 'Saving 10%. Add one more bag to save 15%.';
  return 'Saving 15% on '+n+' bags.';
 }
 function render(){
  const n=M.count(state),selected=M.selected(state),total=quote(),valid=state.ready&&!loadError&&!validation()&&!state.review;
  const every=state.every/7;
  bind('boxLabel',n?n+' '+bagWord(n)+' · '+(n*20)+' sticks':'Your box is empty');
  bind('boxSummary',selected.length?selected.map(k=>state.counts[k]+' × '+names[k]).join(' · '):'Use + to add a bag.');
  bind('mixLabel',!n?'Your box':selected.length>1?'Your flavor mix':names[selected[0]]);
  bind('subPrice',money(quote(n,true).total));
  bind('onePrice',money(quote(n,false).total));
  bind('oneNote',oneTimeNote(n));
  bind('renewal',state.sub&&n?'Renews every '+every+' weeks at '+money(total.total)+' plus shipping and taxes until you cancel.':'');
  bind('mobilePrice',n?money(total.total)+(state.sub?' every '+every+' weeks':' one-time'):'Choose your flavors');
  q('[data-bind="renewal"]').hidden=!(state.sub&&n);
  q('[data-purchase-options]').hidden=!n;
  qa('[data-flavor]').forEach(e=>{
   const inBox=state.counts[e.dataset.flavor]>0;
   if(e.classList.contains('flavor-card')){e.removeAttribute('aria-pressed');e.classList.toggle('is-current',inBox);const label=e.querySelector('.choose');if(label)label.textContent=inBox?'In your box ✓':'Choose flavor →';}
  });
  qa('[data-flavor-select]').forEach(e=>e.value=state.flavor);
  qa('[data-mix-row]').forEach(row=>{
   const k=row.dataset.mixRow,num=state.counts[k],v=M.variant(products,k),soldOut=state.ready&&!loadError&&!v?.available;
   row.classList.toggle('has-bags',num>0);
   row.querySelector('output').textContent=num;
   row.querySelector('[data-item-minus]').disabled=state.busy||!num;
   row.querySelector('[data-item-plus]').disabled=state.busy||num>=99||soldOut;
   const stock=row.querySelector('[data-item-stock]');if(stock)stock.hidden=!soldOut;
  });
  qa('[data-preview-flavor]').forEach(e=>{const k=e.dataset.previewFlavor;e.hidden=state.counts[k]===0;e.querySelector('[data-preview-count]').textContent=state.counts[k]+' '+bagWord(state.counts[k]);});
  q('[data-box-preview]').classList.toggle('is-single',selected.length<2);
  qa('[data-purchase]').forEach(e=>e.checked=(e.value==='sub')===state.sub);
  q('[data-frequency]').value=String(state.every);q('[data-frequency-row]').hidden=!state.sub;
  const add=q('[data-add]');add.disabled=state.busy||!valid;
  add.textContent=state.busy?'Adding your box…':!state.ready?'Checking availability…':!n?'Add a bag to continue':state.review?'Check your cart':valid?'Add to cart · '+money(total.total):'Currently unavailable';
  qa('[data-flavor-select],[data-flavor],[data-purchase],[data-frequency],[data-one-each]').forEach(e=>e.disabled=state.busy);
  qa('[data-pouch]').forEach(e=>{const src=cfg.assets[state.flavor];if(e.getAttribute('src')!==src)e.src=src;e.alt='Buzz Bomb '+names[state.flavor]+' pouch';});
  qa('.stick').forEach(e=>e.hidden=state.flavor!=='variety');
  if(loadError)status('We couldn’t confirm current availability. Please refresh or visit the product page.');
 }
 function notify(event,extra={}){
  const detail={experiment:'buzz-bomb-ui-20261103',design:cfg.design,...extra};
  root.dispatchEvent(new CustomEvent(event,{bubbles:true,detail}));
  if(window.dataLayer&&window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.())window.dataLayer.push({event:event.replaceAll(':','_'),...detail});
 }
 const boxMode=()=>M.selected(state).length>1?'mix':'single';
 function scrollToShop(){
  q('#bbab-shop').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
  notify('bb:shop',{bags:M.count(state),mode:boxMode()});
 }
 async function fetchProducts(keys=M.keys){
  const entries=await Promise.all(keys.map(async k=>{
   const r=await fetch(cfg.base+'products/'+cfg.handles[k]+'.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
   if(!r.ok)throw Error('Could not confirm '+names[k]+'.');
   return [k,await r.json()];
  }));Object.assign(products,Object.fromEntries(entries));
 }
 async function refresh(){
  try{if(!cfg.preview)await fetchProducts();loadError='';}catch(e){loadError='unavailable';}
  state.ready=true;render();
 }
 async function cartRead(){
  const r=await fetch(cfg.base+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
  if(!r.ok)throw Error('Could not confirm cart.');return r.json();
 }
 function itemMatches(line,item){
  return Number(line.variant_id||line.id)===item.id&&Number(line.selling_plan_allocation?.selling_plan?.id||0)===Number(item.selling_plan||0)&&Object.entries(item.properties).every(([k,v])=>line.properties?.[k]===v);
 }
 function cartDelta(before,after,items){
  const qty=(cart,item)=>(cart.items||[]).filter(l=>itemMatches(l,item)).reduce((n,l)=>n+l.quantity,0);
  const complete=items.every(i=>qty(after,i)-qty(before,i)>=i.quantity);
  const old=new Map((before.items||[]).map(l=>[l.key,l.quantity])),updates={};
  for(const line of after.items||[])if(items.some(i=>itemMatches(line,i))&&line.quantity>(old.get(line.key)||0))updates[line.key]=old.get(line.key)||0;
  return {complete,updates};
 }
 function finish(){
  notify('bb:add-to-cart',{value:quote().total/100,currency:cfg.currency,bags:M.count(state),flavors:{...state.counts},mode:boxMode(),subscribe:state.sub,every:state.sub?state.every:null});
  location.assign(cfg.base+'cart');
 }
 async function add(){
  if(state.busy||!state.ready||state.review||validation())return;
  status('');state.busy=true;render();
  let before=null,items=null,attempted=false;
  try{
   if(!cfg.preview)await fetchProducts(M.selected(state));
   items=M.items(state,products,cfg);
   before=await cartRead();attempted=true;
   const r=await fetch(cfg.base+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
   const body=await r.json();
   if(!r.ok)throw Error(body.description||body.message||'Could not add the complete box.');
   finish();return;
  }catch(error){
   if(attempted&&before&&items){
    try{
     const after=await cartRead(),result=cartDelta(before,after,items);
     if(result.complete){finish();return;}
     if(Object.keys(result.updates).length){
      const r=await fetch(cfg.base+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates:result.updates})});
      if(!r.ok)throw Error('Could not restore cart.');
     }
    }catch(confirmError){state.review=true;error=Error('We couldn’t confirm the complete box. Check your cart before trying again.');}
   }
   state.busy=false;render();status(error.message||'Could not add your box. Please adjust your selection.',state.review);
   q('[data-status]').scrollIntoView({block:'nearest'});
  }
 }
 const video=q('[data-reel]'),play=q('[data-play-reel]');
 if(video&&play){
  play.addEventListener('click',()=>{if(video.ended)video.currentTime=0;video.muted=false;video.play().catch(()=>{play.hidden=false;});});
  video.addEventListener('play',()=>{play.hidden=true;notify('bb:reel-play');});
  video.addEventListener('pause',()=>{play.hidden=false;play.setAttribute('aria-label','Continue the Buzz Bomb reel');});
  video.addEventListener('ended',()=>{play.hidden=false;play.setAttribute('aria-label','Replay the Buzz Bomb reel');});
  if('IntersectionObserver'in window)new IntersectionObserver(entries=>{if(!entries[0].isIntersecting&&!video.paused)video.pause();},{threshold:.1}).observe(video);
 }
 root.addEventListener('click',e=>{
  const t=e.target.closest('button,a');if(!t||!root.contains(t))return;
  if(t.matches('[data-menu]')){const on=t.getAttribute('aria-expanded')!=='true';t.setAttribute('aria-expanded',String(on));q('[data-nav]').classList.toggle('is-open',on);return;}
  if(t.closest('[data-nav]')){q('[data-nav]').classList.remove('is-open');q('[data-menu]').setAttribute('aria-expanded','false');}
  if(t.matches('[data-shop]')){e.preventDefault();scrollToShop();return;}
  if(t.matches('[data-add]')){e.preventDefault();add();return;}
  if(state.busy)return;
  if(t.matches('[data-one-each]'))M.each(state);
  else if(t.dataset.itemPlus)M.change(state,t.dataset.itemPlus,1);
  else if(t.dataset.itemMinus)M.change(state,t.dataset.itemMinus,-1);
  else if(t.dataset.flavor)M.pick(state,t.dataset.flavor);
  else if(t.dataset.cycle)M.browse(state,M.keys[(M.keys.indexOf(state.flavor)+Number(t.dataset.cycle)+M.keys.length)%M.keys.length]);
  else return;
  status('');render();
  if(t.hasAttribute('data-choose')||t.hasAttribute('data-one-each-jump'))scrollToShop();
 });
 root.addEventListener('change',e=>{
  if(state.busy){render();return;}const t=e.target;
  if(t.matches('[data-flavor-select]'))M.browse(state,t.value);
  else if(t.matches('[data-purchase]'))state.sub=t.value==='sub';
  else if(t.matches('[data-frequency]'))state.every=Number(t.value);
  else return;
  status('');render();
 });
 root.addEventListener('keydown',e=>{if(e.key==='Escape'){q('[data-nav]').classList.remove('is-open');q('[data-menu]').setAttribute('aria-expanded','false');}});
 qa('.faq-item').forEach(d=>d.addEventListener('toggle',()=>{if(d.open)qa('.faq-item').forEach(o=>{if(o!==d)o.open=false;});}));
 if('IntersectionObserver'in window){
  let hero=true,shop=false;const bar=q('[data-mobile-shop]'),update=()=>bar.classList.toggle('is-visible',!hero&&!shop);
  new IntersectionObserver(es=>{hero=es[0].isIntersecting;update();},{threshold:0}).observe(q('[data-hero]'));
  new IntersectionObserver(es=>{shop=es[0].isIntersecting;update();},{threshold:0}).observe(q('[data-purchase-form]'));
 }
 render();refresh();notify('bb:variant-view');
})();
